import { GroupRoutineType } from '../types/grouproutines.type';
import { HTTPServices } from './base.service';

export class GroupRoutinesServices extends HTTPServices {
    private static BASE_ROUTE = 'grouproutines/';

    static getAllWarmups() {
        return GroupRoutinesServices.get<GroupRoutineType[]>(GroupRoutinesServices.BASE_ROUTE + 'warmups');
    }
    static getAllWorkoutRoutines() {
        return GroupRoutinesServices.get<GroupRoutineType[]>(GroupRoutinesServices.BASE_ROUTE + 'workouts');
    }

    static add(data: GroupRoutineType) {
        return GroupRoutinesServices.post<GroupRoutineType>(GroupRoutinesServices.BASE_ROUTE, data);
    }

    static addWarmUpRoutine(data: GroupRoutineType) {
        return GroupRoutinesServices.post<GroupRoutineType>(GroupRoutinesServices.BASE_ROUTE, { ...data, phase: 'warmup' });
    }

    static addWorkoutRoutine(data: GroupRoutineType) {
        return GroupRoutinesServices.post<GroupRoutineType>(GroupRoutinesServices.BASE_ROUTE, { ...data, phase: 'workout' });
    }

    static update(id: number, data: GroupRoutineType) {
        return GroupRoutinesServices.put<GroupRoutineType>(GroupRoutinesServices.BASE_ROUTE + id, data);
    }

    static getById(id: number) {
        return GroupRoutinesServices.get<GroupRoutineType>(GroupRoutinesServices.BASE_ROUTE + id);
    }

    static deleteById(id: number) {
        return GroupRoutinesServices.delete<GroupRoutineType[]>(GroupRoutinesServices.BASE_ROUTE + id);
    }
}
